import { CompanyStatus } from './company.interface';
import { UserRoleEnum } from './user-profile.interface';

export enum ProfileStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface IProfile {
  id: string;
  email: string;
  phone: string;
  details: string;
  role: UserRoleEnum;
  status: ProfileStatus;
  company_id: number;
  company: { id: number; status: CompanyStatus };
}

export interface IProfileCreateDTO {
  id: string;
  email: string;
  phone?: string;
  details?: string;
  role: UserRoleEnum;
  status?: ProfileStatus;
  company_id?: number;
}
